// ─── Core Domain Types ────────────────────────────────────────────────────────
export const DEFAULT_LAYOUT = {
    laneHeight: 160,
    eventWidth: 220,
    eventHeight: 90,
    eventSpacing: 300,
    paddingLeft: 180,
    paddingTop: 40,
};
export const STATUS_COLORS = {
    unchecked: { bg: '#f9fafb', border: '#e5e7eb', text: '#374151' },
    success: { bg: '#f0fdf4', border: '#86efac', text: '#166534' },
    failure: { bg: '#fef2f2', border: '#fca5a5', text: '#991b1b' },
    skipped: { bg: '#fefce8', border: '#fde047', text: '#713f12' },
};
export const TIMELINE_COLORS = [
    '#6366f1', '#8b5cf6', '#ec4899', '#ef4444',
    '#f97316', '#eab308', '#22c55e', '#14b8a6',
    '#06b6d4', '#3b82f6',
];
